import { render } from "./FrivilligjobCard.vue?vue&type=template&id=0edeb298"
import script from "./FrivilligjobCard.vue?vue&type=script&lang=js"
export * from "./FrivilligjobCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__